import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { App } from '@galaxy/marketplace-apps';
import { Package } from '@vendasta/marketplace-packages';
import { combineLatest, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { SalesOrderLineItemSelectorComponent } from '../../sales-order-line-item-selector/sales-order-line-item-selector.component';

export interface SalesOrderLineItemSelectorDialogData {
  marketId?: string;
  preselectedPackages: Package[];
  preselectedApps: App[];
  hideSellingStandaloneProducts: boolean;
  hidePackages?: boolean;
  hideOwnerName?: boolean;
  hideOrderFormProducts?: boolean;
  wholesalePricing?: boolean;
}

export interface SalesOrderLineItemSelectorDialogResult {
  packages: Package[];
  apps: App[];
}

@Component({
  selector: 'sales-ui-sales-order-line-item-selector-dialog',
  templateUrl: 'sales-order-line-item-selector-dialog.component.html',
  styleUrls: ['sales-order-line-item-selector-dialog.component.scss'],
  standalone: false,
})
export class SalesOrderLineItemSelectorDialogComponent {
  marketId: string;
  preselectedPackages: Package[];
  preselectedApps: App[];
  hideSellingStandaloneProducts: boolean;
  hidePackages: boolean;
  hideOwnerName: boolean;
  hideOrderFormProducts: boolean;
  wholesalePricing: boolean;

  @ViewChild(SalesOrderLineItemSelectorComponent, { static: true })
  selectorComponent: SalesOrderLineItemSelectorComponent;

  constructor(
    @Inject('PARTNER_ID') readonly partnerId$: Observable<string>,
    @Inject(MAT_DIALOG_DATA) public data: SalesOrderLineItemSelectorDialogData,
    public dialogRef: MatDialogRef<SalesOrderLineItemSelectorDialogComponent, SalesOrderLineItemSelectorDialogResult>,
  ) {
    this.marketId = data.marketId;
    this.preselectedPackages = data.preselectedPackages;
    this.preselectedApps = data.preselectedApps;
    this.hideSellingStandaloneProducts = data.hideSellingStandaloneProducts;
    this.hidePackages = data.hidePackages || false;
    this.hideOwnerName = data.hideOwnerName || false;
    this.hideOrderFormProducts = data.hideOrderFormProducts || false;
    this.wholesalePricing = data.wholesalePricing || false;
  }

  selectPackages(): void {
    combineLatest([
      this.selectorComponent.getSelectedAppsWithRetailPricing(),
      this.selectorComponent.getSelectedPackages(),
    ])
      .pipe(take(1))
      .subscribe(([apps, packages]) => {
        this.dialogRef.close({
          packages: packages,
          apps: apps,
        });
      });
  }
}
